// public/js/features/pois/api.js
// Thin wrappers around the POI REST endpoints (mirrors features/assets/api.js).

export async function loadPoiData() {
  const res = await window.authenticatedFetch('api/v1/pois');
  if (!res.ok) throw new Error('Failed to load POIs');
  const data = await res.json();
  return { types: data.types || [], pois: data.pois || [] };
}

export async function loadMyTenants() {
  const res = await window.authenticatedFetch('api/v1/my-tenants');
  if (!res.ok) throw new Error('Failed to load tenants');
  return await res.json(); // { canCreatePublic, tenants: [{tenantId,name}] }
}

export async function createPoi(data) {
  const res = await window.authenticatedFetch('api/v1/pois', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error((await safeErr(res)) || 'Create failed');
  return await res.json();
}

export async function updatePoi(poiId, updates) {
  const res = await window.authenticatedFetch(`api/v1/pois/${encodeURIComponent(poiId)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updates),
  });
  if (!res.ok) throw new Error((await safeErr(res)) || 'Update failed');
  return await res.json();
}

export async function deletePoi(poiId) {
  const res = await window.authenticatedFetch(`api/v1/pois/${encodeURIComponent(poiId)}`, { method: 'DELETE' });
  if (!res.ok) throw new Error((await safeErr(res)) || 'Delete failed');
  return await res.json();
}

export async function createPoiType(data) {
  const res = await window.authenticatedFetch('api/v1/poi-types', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error((await safeErr(res)) || 'Create failed');
  return await res.json();
}

export async function updatePoiType(typeId, updates) {
  const res = await window.authenticatedFetch(`api/v1/poi-types/${encodeURIComponent(typeId)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updates),
  });
  if (!res.ok) throw new Error((await safeErr(res)) || 'Update failed');
  return await res.json();
}

export async function deletePoiType(typeId) {
  const res = await window.authenticatedFetch(`api/v1/poi-types/${encodeURIComponent(typeId)}`, { method: 'DELETE' });
  if (!res.ok) throw new Error((await safeErr(res)) || 'Delete failed');
  return await res.json();
}

// Upload a custom-map overlay image for a POI; returns { key }.
export async function uploadOverlayImage(poiId, { dataBase64, contentType }) {
  const res = await window.authenticatedFetch(`api/v1/pois/${encodeURIComponent(poiId)}/overlay-image`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ dataBase64, contentType }),
  });
  if (!res.ok) throw new Error((await safeErr(res)) || 'Upload failed');
  return await res.json();
}

async function safeErr(res) {
  try { return (await res.json()).error; } catch { return null; }
}
